export const CREATE_NEW_PRODUCT_ACCESS = ["CM", "PC"];
export const INITIATE_VA = ["PC", "CM"];
export const REVIEW_VA = ["PC", "CM"];

export const FEATURE_IDS = {
  RA_VS: 1, // Reporting & Analytics | Vendor Scorecard
  RA_PS: 2, // Reporting & Analytics | Product Scorecard
  RA_WSR: 3, // Reporting & Analytics | Weekly Status Report
  RA_WSMR: 4, // Reporting & Analytics | Workflow Status Monitoring Report
  CP_SLM: 5, // Create Product | Shopping List Management
  CP_VA: 6, // Create Product | Vendor Assessment
  CP_PFP: 7, // Create Product | Prepare for Panel
  TP_BRP: 8, // Tasting Panel | Business Review Panel
  TP_TP: 9, // Tasting Panel | Tasting panel
  VM_VS: 10, // Vendor Management | Vendor Sites
  VM_AV: 11, // Vendor Management | Audits and Visits
  VM_VL: 12, // Vendor Management | Vendor Library
  VM_VUM: 13, // Vendor Management | Vendor User Management
  VM_VUM_VENDOR: 39, // Vendor Management | Vendor User Management (Vendor token feature id)
  VM_VRM: 14, // Vendor Management | Vendor Role Management
  VM_VCGM: 15, // Vendor Management | Vendor Contact Group Management
  AP_AP: 16, // Active Projects | Active Project
  PD_PD: 25, // Product Detail | Product Detail
  SO_SO: 26, // Store Orderability | Store Orderability
  LP_LP: 24,
  DA_MA: 17, // Design & Artwork | MyArtwork/Opal
  DA_PIA: 18, // Design & Artwork | Projects in Artwork
  AM_TJRM: 19, // Admin Management | TJ Role Management
  AM_TJUM: 20, // Admin Management | TJ User Management
  AM_TJGM: 21, // Admin Management | TJ Group Management
  AM_GM: 22, // Admin Management | Glossary Management
  VM_VCLM: 43, // Vendor Management | Vendor Contact Group Management
};

export const ACCESS_KEYS = {
  CREATE_OR_SUBMIT: "Create/Submit",
  UPDATE: "Update",
  DELETE: "Delete",
  CANCEL: "Cancel",
  HOLD: "Hold",
  APPROVE_OR_REJECT: "Approve/Reject",
  VIEW: "View(Comment capabilities)",
} as const;
